import { Dialog } from "components/Dialog";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { DataGridRef } from "devextreme-react/data-grid";
import RolesGrid from "./RolesGrid";
import { TRolesGridRow } from "./RolesGrid/types";

import { TRole } from "types/dto";
import { netCall } from "utils/netCall";
import { UserManagementApiUrl } from "environment/routeSettings";
import { Button } from "components/Button";
import { TResponseCode } from "utils/netCall/types";

type TProps = {
  isOpen?: boolean;
  onClose: () => void;
  onSubmitSelectedRoles: (value: TRolesGridRow[]) => void;
};

export type TAddFormTypes = {
  apartmentId: string;
  floorNo: number;
  unitNo: string;
  identifierId: string;
  subscriberName: string;
  nationalId: string;
  phoneNumber: string;
  mobileNumber: string;
  postalCode: string;
  email: string;
  waterMeterId: string;
  installationDT: Date;
};

export function RolesChooserModal(props: TProps) {
  const { isOpen = false, onClose, onSubmitSelectedRoles } = props;

  const { t } = useTranslation();

  const [rolesData, setRolesData] = useState<TRole[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const GridRef = useRef<DataGridRef<any, any>>(null);

  const onSubmitClick = () => {
    const selectedRoles = GridRef?.current?.instance()?.getSelectedRowsData();
    if (selectedRoles && selectedRoles.length > 0) {
      onSubmitSelectedRoles(selectedRoles);
    }
  };

  const getRoles = async () => {
    setIsLoading(true);
    const res = await netCall<TRole[]>({
      method: "GET",
      endPoint: `${UserManagementApiUrl()}/api/SamaRole/GetRoles`,
    });
    if (res.responseCode === TResponseCode.OK) {
      const records = res.results;
      setRolesData(records);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("chooseRoles")}
      open={isOpen}
      onClose={onClose}
    >
      <div className={"p-4"}>
        <p className={"text-gray-110 mr-3 text-sm my-1"}>
          {t("chooseRolesFromList")}
        </p>
        <div className={"w-[1080px] h-[620px] px-2"}>
          <RolesGrid
            rolesData={rolesData}
            isLoading={isLoading}
            ref={GridRef}
          />
        </div>
        <div className="col-span-12 flex items-center justify-end mt-3">
          <Button
            className="w-20"
            onClick={() => onSubmitClick()}
            variant="contained"
          >
            {t("add")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
